import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { right } from '@popperjs/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from '../../services/network.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';
import { getCountryLabel } from '../../utility/country.util';

@Component({
  selector: 'app-inventory-view',
  templateUrl: './inventory-view.component.html',
  styleUrls: ['./inventory-view.component.css']
})
export class InventoryViewComponent implements OnInit, OnDestroy {

  settings = {
    actions: {
      custom: [
        {
          name: 'productRelationship',
          title: '<i class="fa-solid fa-arrow-right fa-2x" title="Product Relationship"></i>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: right,
      columnTitle: 'View More',
      sort: false
    },
    columns: {
      lead: {
        title: 'Lead Operator',
        valuePrepareFunction: (operator: string) => {
          return operator === 'IMSA' ? 'DEUTSCHE TELEKOM' : operator;
        }
      },
      owner: {
        title: 'B Operator',
        valuePrepareFunction: (operator: string) => {
          return operator === 'IMSA' ? 'DEUTSCHE TELEKOM' : operator;
        }
      },
      globalCustomerName: {
        title: 'Global Customer Name'
      },
      country: {
        title: 'Country',
        valuePrepareFunction: (country: string) => {
          return getCountryLabel(country);
        }
      },
      localCustomer: {
        title: 'Local Customer'
      },
      localCutomerName: {
        title: 'Local Customer Name'
      },
      productId: {
        title: 'Asset Id'
      },
      productOrderId: {
        title: 'Order Id'
      },
      productName: {
        title: 'Product Name'
      },
      msisdn: {
        title: 'MSISDN'
      },
      iccid: {
        title: 'ICCID'
      }


    },
    pager: {
      display: false
    }
  };

  listInventory: any[] = [];
  listInventoryAdds: any[] = [];
  destroy$ = new Subject<boolean>();

  constructor(private networkService: NetworkService, private toastr: ToastrManager,
    private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit(): void {
    this.initializeListInventory();

  }

  initializeListInventory() {

    this.spinner.show("sp1");
    let urlCatalog: string = environment.basePath + _ENDPOINT.getAllInventory;
    let request = {
      lastId: "",
      lastTimeStamp: "",
      limit: "50"
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlCatalog, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.listInventory = JSON.parse(response.body);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && Array.isArray(response)) {
            this.listInventory = response;
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Inventory Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Inventory Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  loadMoreInventory() {
    if (this.listInventory && this.listInventory.length > 0) {
      let inventory: any = this.listInventory[this.listInventory.length - 1];
      this.loadOtherInventory(inventory);
    }
  }

  loadOtherInventory(inventory: any) {

    this.spinner.show("sp1");
    let urlCatalog: string = environment.basePath + _ENDPOINT.getAllInventory;
    let request = {
      lastId: inventory.productId,
      lastTimeStamp: inventory.createdAt,
      limit: "50"
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlCatalog, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.listInventoryAdds = JSON.parse(response.body);
            this.listInventory = this.listInventory.concat(this.listInventoryAdds);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && Array.isArray(response)) {
            this.listInventoryAdds = response;
            this.listInventory = this.listInventory.concat(this.listInventoryAdds);
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Inventory Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Inventory Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  viewLoadMoreInventory() {
    if (this.listInventory && this.listInventory.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  onCustomAction(event: any) {
    switch (event.action) {
      case 'productRelationship':
        let url: string = 'product-relationship-view/' + event.data.productId;
        this.router.navigate([url]);
        break;


    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

